import { render, staticRenderFns } from "./StaffApplicationDocuments.vue?vue&type=template&id=066b799f&"
import script from "./StaffApplicationDocuments.vue?vue&type=script&lang=js&"
export * from "./StaffApplicationDocuments.vue?vue&type=script&lang=js&"
import style0 from "./StaffApplicationDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports